import _ from 'underscore'
import Backbone from 'backbone'
import Account from 'app/models/account'

const AccountList = Backbone.Collection.extend({
    model: Account
});

export default AccountList;

/**
 * Generates a new AccountList from the accounts hash received from the server.
 *
 * Iterates over the accounts hash, associates all members account if the account type is "s",
 * and returns a new AccountList instance containing the processed accounts.
 *
 * @param {Object} accountsHash - The hash of accounts returned from the server.
 * @param {Object} currentUser - The Account model associated with the logged-in user.
 * @returns {AccountList} A new AccountList instance populated with accounts from the hash.
 */
export function accountListfromHash(accountsHash, currentUser) {
    let models = [];

    _.each(accountsHash, function(account) {
        if (account.accounttype === "s") {
            currentUser.associateAllMembersAccount(account);
        }

        models.push(account);
    });

    return new AccountList(models);
}
